import { createRentalAccessStore } from './rentalAccessStore'

/** Resposta a "devo ver as páginas do inquilino em Arrendamento?" — ver `useRentalTenantAccess`. */
const store = createRentalAccessStore('/api/arrendamentos/inquilino/acesso')

export const getRentalTenantAccessSnapshot = store.getSnapshot
export const subscribeRentalTenantAccess = store.subscribe
export const loadRentalTenantAccess = store.load
export const invalidateRentalTenantAccess = store.invalidate
